import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../../Services/translation';
import { close } from '../../../Actions/Configurator.action';
import ProductServiceBlasting from '../ProductServiceBlasting';
import ProductServiceCutting from '../ProductServiceCutting';
import ProductServiceSwell from '../ProductServiceSwell';
import ConfiguratorProductDetails from '../ConfiguratorProductDetails';
import ModeSelection from './ModeSelection';

// Icons
import paintBrush from '../../../../images/Paintbrush.svg';
import plusIcon from '../../../../images/plusIcon.svg';
import cutingIcon from '../../../../images/cutingIcon.svg';
import splittingIcon from '../../../../images/splittingIcon.svg';
import closeDialogIcon from '../../../../images/closeDialogIcon.svg';

const ProductionPane = () => {
  const dispatch = useDispatch(),
    configurator = useSelector((state) => state.configurator),
    rules = useSelector((state) => state.configurator.rules);

  const selectedProductServiceTab = configurator.selectedProductServiceTab || 0;
  return (
    <div className='configurator-pane configurator-pane--production'>
      {selectedProductServiceTab === 0 && (
        <Fragment>
          <a className='configurator-close-button' onClick={() => dispatch(close())} >
            <img src={closeDialogIcon} />
          </a>
          <h4 className='productionTitle'>
            {translate('configurator.service.adjust')}
          </h4>
          <ConfiguratorProductDetails />

          <section className='configurator-box'>
            <header>
              <svg className='configurator-box__icon'>
                <use href='/ui/images/sprites/be-group.svg#customize'></use>
              </svg>
              <h4 className='configurator-box__title'>
                {translate('config.productionservices')}
              </h4>
            </header>
            <div className='configurator-box__content'>
              {(rules.allowBlasting === true || rules.allowPainting === true) && (
                <ModeSelection
                  tab={1}
                  icon={paintBrush}
                  title={translate('blasting.title')}
                  text={translate('blasting.description')}
                />
              )}
              <ModeSelection
                tab={2}
                icon={cutingIcon}
                title={translate('configurator.service.cutting.title')}
                text={translate('configurator.service.cutting.description')}
              />
              {/* <ModeSelection tab={3} icon={splittingIcon} title={translate('configurator.service.swell.title')} text={translate('configurator.service.swell.description')} /> */}
            </div>
          </section>
        </Fragment>
      )}

      {selectedProductServiceTab === 1 && <ProductServiceBlasting />}
      {selectedProductServiceTab === 2 && <ProductServiceCutting />}
      {selectedProductServiceTab === 3 && <ProductServiceSwell />}
    </div>
  );
};

export default ProductionPane;
